__turbopack_context__.v({
  "content": "content-module-scss-module__Njc9Qa__content",
});
